import { VueReCaptcha } from 'vue-recaptcha-v3'

// El plugin habilita el uso de Google reCAPTCHA en una aplicación Nuxt.js
// registrando el plugin VueReCaptcha con las opciones de configuración necesarias.
export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  
  const options = {
    siteKey: runtimeConfig.public.recaptcha?.siteKey || '6Lckb-cpAAAAAM_VhOM5CS_w2H5hGwORU1eFJSKe',
    loaderOptions: {
      autoHideBadge: true,
      useRecaptchaNet: true,
      renderParameters: {
        hl: 'es' // Cambiado de 'id' a 'es' para español
      }
    }
  }
  
  nuxtApp.vueApp.use(VueReCaptcha, options)
  
  return {
    provide: {
      recaptcha: VueReCaptcha
    }
  }
})
